import { apiClient } from "../apiClient";
import { API_ENDPOINTS } from "@repo/constants";
import { AxiosError } from "axios";
import {
  UpdateAdminPasswordRequest,
  UpdateAdminPasswordResponse,
  AdminCreateRequest,
  AdminCreateResponse,
  AdminListRequest,
  AdminListResponse,
  AdminListByIdRequest,
  AdminListByIdResponse,
} from "@repo/types";

/* ------------------------------------------
   Reusable API Post Wrapper
------------------------------------------ */

const safePost = async <T>(
  url: string,
  payload: any,
  fallbackData?: Partial<T>
): Promise<T> => {
  try {
    const response = await apiClient.post<T>(url, payload);
    return response.data;
  } catch (err) {
    const error = err as AxiosError<any>;
    console.error(`API Error [${url}]:`, error);

    const apiMessage =
      error.response?.data?.Message ||
      error.message ||
      "An unexpected error occurred";

    return {
      Success: false,
      Message: apiMessage,
      StatusCode: 500,
      ...fallbackData,
    } as T;
  }
};

/* ------------------------------------------
   APIs (Same Structure, Cleaner)
------------------------------------------ */

export const OneDeskUpdatePassword = (
  payload: Partial<UpdateAdminPasswordRequest>
): Promise<UpdateAdminPasswordResponse> =>
  safePost<UpdateAdminPasswordResponse>(
    API_ENDPOINTS.adminUpdatePassword,
    payload
  );

export const adminCreate = (
  payload: Partial<AdminCreateRequest>
): Promise<AdminCreateResponse> =>
  safePost<AdminCreateResponse>(
    API_ENDPOINTS.AddAdmin,
    payload
  );

export const adminList = (
  payload: Partial<AdminListRequest>
): Promise<AdminListResponse> =>
  safePost<AdminListResponse>(
    API_ENDPOINTS.adminList,
    payload,
    { Data: [] }
  );

export const adminById = (
  payload: Partial<AdminListByIdRequest>
): Promise<AdminListByIdResponse> =>
  safePost<AdminListByIdResponse>(
    API_ENDPOINTS.adminListById,
    payload,
    { Data: [] }
  );












// import { apiClient } from "../apiClient";
// import { API_ENDPOINTS } from "@repo/constants";
// import { AxiosError } from "axios";
// import {
//     UpdateAdminPasswordRequest,
//     UpdateAdminPasswordResponse,
//     AdminCreateRequest,
//     AdminCreateResponse,
//     AdminListRequest,
//     AdminListResponse,
//     AdminListByIdRequest,
//     AdminListByIdResponse,
// } from "@repo/types";

// export const OneDeskUpdatePassword = async (
//     payload: Partial<UpdateAdminPasswordRequest>
// ): Promise<UpdateAdminPasswordResponse> => {
//     try {
//         const response = await apiClient.post<UpdateAdminPasswordResponse>(
//             API_ENDPOINTS.adminUpdatePassword,
//             payload
//         );
//         return response.data;
//     } catch (err) {
//         const error = err as AxiosError<any>;
//         console.error("Error updating admin password:", error);
//         const apiMessage =
//             error.response?.data?.Message ||
//             error.message ||
//             "An unexpected error occurred";
//         return { Success: false, Message: apiMessage, StatusCode: 500 };
//     }
// };

// export const adminCreate = async (
//     payload: Partial<AdminCreateRequest>
// ): Promise<AdminCreateResponse> => {
//     try {
//         const response = await apiClient.post<AdminCreateResponse>(
//             API_ENDPOINTS.AddAdmin,
//             payload
//         );
//         return response.data;
//     } catch (err) {
//         const error = err as AxiosError<any>;
//         console.error("Error creating admin:", error);
//         const apiMessage =
//             error.response?.data?.Message ||
//             error.message ||
//             "An unexpected error occurred";
//         return { Success: false, Message: apiMessage, StatusCode: 500 };
//     }
// };

// export const adminList = async (
//     payload: Partial<AdminListRequest>
// ): Promise<AdminListResponse> => {
//     try {
//         const response = await apiClient.post<AdminListResponse>(
//             API_ENDPOINTS.adminList,
//             payload
//         );
//         // console.log("Admin list response:", response.data);
//         return response.data;
//     } catch (err) {
//         const error = err as AxiosError<any>;
//         console.error("Error fetching admin list:", error);
//         const apiMessage =
//             error.response?.data?.Message ||
//             error.message ||
//             "An unexpected error occurred";
//         return {
//             Success: false,
//             Message: apiMessage,
//             StatusCode: 500,
//             Data: [],
//         };
//     }
// };

// export const adminById = async (
//     payload: Partial<AdminListByIdRequest>
// ): Promise<AdminListByIdResponse> => {
//     try {
//         const response = await apiClient.post<AdminListByIdResponse>(
//             API_ENDPOINTS.adminListById,
//             payload
//         );
//         return response.data;
//     } catch (err) {
//         const error = err as AxiosError<any>;
//         console.error("Error fetching admin list by id:", error);
//         const apiMessage =
//             error.response?.data?.Message ||
//             error.message ||
//             "An unexpected error occurred";
//         return {
//             Success: false,
//             Message: apiMessage,
//             StatusCode: 500,
//             Data: [],
//         };
//     }
// };